import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { userInfoKeys } from 'api/queryKeys/queryKeys';
import { signOut } from 'api/sessionApi';
import {
  getMyInfo,
  MyInfoFormData,
  PassFormData,
  useChangePasswordMutation,
  useUpdateMyInfoMutation,
} from 'api/userApi';
import { useRecoilState, useResetRecoilState } from 'recoil';

import { userInfoState } from 'globalState/user/atom';
import PasswordModal from './PasswordModal';
import UserInfoForm from './UserInfoForm';

export type ModalPropType = {
  isOpen: boolean;
  onSubmit: (formData: PassFormData) => void;
};

function Mypage() {
  const queryClient = useQueryClient();

  const { data, refetch } = useQuery({
    queryKey: userInfoKeys.details(),
    queryFn: () => getMyInfo(),
  });

  const [isPasswordModalOpen, setIsPasswordModal] = useState(false);

  const onPasswordModalOpen = () => {
    setIsPasswordModal(true);
  };
  const onPasswordModalClose = () => {
    setIsPasswordModal(false);
  };

  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const resetUserInfo = useResetRecoilState(userInfoState);
  const navigate = useNavigate();
  const handleSignOut = async () => {
    await signOut();
    resetUserInfo();
    queryClient.clear();
    sessionStorage.clear();
    navigate('/sign-in');
  };
  const changePasswordMutation = useChangePasswordMutation();
  const handleSubmit = (formData: PassFormData) => {
    changePasswordMutation.mutate(formData, {
      onSuccess: (response) => {
        if (response.code === 200) {
          onPasswordModalClose();
          alert('비밀번호가 변경되었습니다 다시 로그인해주세요');

          handleSignOut();
        } else {
          alert(response.message);
        }
      },
    });
  };
  const editUserMutate = useUpdateMyInfoMutation();
  const handleUserInfoSubmit: SubmitHandler<MyInfoFormData> = (formData: MyInfoFormData) => {
    editUserMutate.mutate(formData, {
      onSuccess: () => {
        refetch();
        setUserInfo((prev) => ({ ...prev, name: formData.name }));
        alert('내정보가 수정 되었습니다.');
        navigate('/home', { replace: true });
      },
    });
  };

  return (
    <section className={'mypage'}>
      <UserInfoForm
        item={data?.info}
        onPasswordModalClick={onPasswordModalOpen}
        onSubmit={handleUserInfoSubmit}
      />
      <PasswordModal
        isOpen={isPasswordModalOpen}
        onClose={onPasswordModalClose}
        onSubmit={handleSubmit}
      />
    </section>
  );
}

export default Mypage;
